export default "__VITE_ASSET__CMCVu$Op__"